/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContentCategoryDto,
  SearchCategory1Params
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const searchCategory1 = (
    params: SearchCategory1Params,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContentCategoryDto[]>(
      {url: `/api/categories`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchCategory1InfiniteQueryKey = (params?: SearchCategory1Params,) => {
    return [
    'infinite', `/api/categories`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchCategory1QueryKey = (params?: SearchCategory1Params,) => {
    return [
    `/api/categories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchCategory1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchCategory1>>>, TError = unknown>(params: SearchCategory1Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCategory1InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCategory1>>> = ({ signal }) => searchCategory1(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchCategory1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchCategory1>>>
export type SearchCategory1InfiniteQueryError = unknown


export function useSearchCategory1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCategory1>>>, TError = unknown>(
 params: SearchCategory1Params, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCategory1>>,
          TError,
          Awaited<ReturnType<typeof searchCategory1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCategory1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCategory1>>>, TError = unknown>(
 params: SearchCategory1Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCategory1>>,
          TError,
          Awaited<ReturnType<typeof searchCategory1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCategory1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCategory1>>>, TError = unknown>(
 params: SearchCategory1Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchCategory1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCategory1>>>, TError = unknown>(
 params: SearchCategory1Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchCategory1InfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchCategory1QueryOptions = <TData = Awaited<ReturnType<typeof searchCategory1>>, TError = unknown>(params: SearchCategory1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCategory1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCategory1>>> = ({ signal }) => searchCategory1(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchCategory1QueryResult = NonNullable<Awaited<ReturnType<typeof searchCategory1>>>
export type SearchCategory1QueryError = unknown


export function useSearchCategory1<TData = Awaited<ReturnType<typeof searchCategory1>>, TError = unknown>(
 params: SearchCategory1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCategory1>>,
          TError,
          Awaited<ReturnType<typeof searchCategory1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCategory1<TData = Awaited<ReturnType<typeof searchCategory1>>, TError = unknown>(
 params: SearchCategory1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCategory1>>,
          TError,
          Awaited<ReturnType<typeof searchCategory1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCategory1<TData = Awaited<ReturnType<typeof searchCategory1>>, TError = unknown>(
 params: SearchCategory1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchCategory1<TData = Awaited<ReturnType<typeof searchCategory1>>, TError = unknown>(
 params: SearchCategory1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCategory1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchCategory1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




